import * as React from "react";
import { cn } from "../lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, type, ...props }, ref) => {
    return (
      <input
        type={type}
        ref={ref}
        className={cn(
          "block w-full h-[42px] px-3 text-[13px] rounded-base border bg-surface text-ink transition-colors",
          "placeholder:text-ink-subtle",
          "focus:outline-none focus:border-primary focus:shadow-[0_0_0_3px_rgb(43_111_216/0.08)]",
          "disabled:cursor-not-allowed disabled:opacity-50",
          error ? "border-danger" : "border-border-strong",
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
